'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useCallback } from 'react';
import { MediaPlayer, MediaProvider } from '@vidstack/react';
const VidstackPlayer = t0 => {
  const $ = _c(44);
  const {
    children,
    source,
    poster,
    volume: t1,
    playbackRate: t2,
    muted: t3,
    isPlaying,
    onPlay,
    onPause,
    onSeekRequest,
    onTimeUpdate,
    onVolumeChange,
    onError,
    onLoaded,
    onLoadStart
  } = t0;
  const volume = t1 === undefined ? 1 : t1;
  const playbackRate = t2 === undefined ? 1 : t2;
  const muted = t3 === undefined ? false : t3;
  const playerRef = useRef(null);
  let t4;
  if ($[0] !== onLoaded) {
    t4 = () => {
      onLoaded?.();
    };
    $[0] = onLoaded;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const handleLoadedMetadata = t4;
  let t5;
  if ($[2] !== onLoadStart) {
    t5 = () => {
      onLoadStart?.();
    };
    $[2] = onLoadStart;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const handlePlayRequest = t5;
  let t6;
  if ($[4] !== onPlay) {
    t6 = () => {
      onPlay?.();
    };
    $[4] = onPlay;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const handlePlay = t6;
  let t7;
  if ($[6] !== onError) {
    t7 = error => {
      if (onError) {
        onError(error);
      }
    };
    $[6] = onError;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const handlePlayFail = t7;
  let t8;
  if ($[8] !== onPlay) {
    t8 = () => {
      onPlay?.();
    };
    $[8] = onPlay;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const handlePlaying = t8;
  let t9;
  if ($[10] !== onPause) {
    t9 = () => {
      onPause?.();
    };
    $[10] = onPause;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const handlePause = t9;
  let t10;
  if ($[12] !== onTimeUpdate) {
    t10 = () => {
      const player = playerRef.current;
      if (player && onTimeUpdate) {
        onTimeUpdate(player.currentTime, player.duration);
      }
    };
    $[12] = onTimeUpdate;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const handleTimeUpdate = t10;
  let t11;
  if ($[14] !== onVolumeChange) {
    t11 = () => {
      const player_0 = playerRef.current;
      if (player_0 && onVolumeChange) {
        onVolumeChange(player_0.volume, player_0.muted);
      }
    };
    $[14] = onVolumeChange;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  const handleVolumeChange = t11;
  let t12;
  if ($[16] !== onError) {
    t12 = detail => {
      if (detail?.error && onError) {
        onError?.(detail.error);
      }
    };
    $[16] = onError;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  const handleError = t12;
  let t13;
  let t14;
  if ($[18] !== isPlaying || $[19] !== muted || $[20] !== volume) {
    t13 = () => {
      const player_1 = playerRef.current;
      if (player_1) {
        player_1.volume = volume;
        player_1.muted = muted;
        if (isPlaying) {
          player_1.play();
        } else {
          player_1.pause();
        }
      }
    };
    t14 = [volume, muted, isPlaying];
    $[18] = isPlaying;
    $[19] = muted;
    $[20] = volume;
    $[21] = t13;
    $[22] = t14;
  } else {
    t13 = $[21];
    t14 = $[22];
  }
  useEffect(t13, t14);
  let t15;
  if ($[23] !== onSeekRequest) {
    t15 = detail_0 => {
      if (onSeekRequest) {
        onSeekRequest(detail_0);
      }
    };
    $[23] = onSeekRequest;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <MediaProvider />;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== children || $[27] !== handleError || $[28] !== handleLoadedMetadata || $[29] !== handlePause || $[30] !== handlePlay || $[31] !== handlePlayFail || $[32] !== handlePlayRequest || $[33] !== handlePlaying || $[34] !== handleTimeUpdate || $[35] !== handleVolumeChange || $[36] !== muted || $[37] !== onLoadStart || $[38] !== onLoaded || $[39] !== playbackRate || $[40] !== poster || $[41] !== source || $[42] !== t15) {
    t17 = <MediaPlayer playsInline={true} autoPlay={true} src={source} ref={playerRef} poster={poster} muted={muted} playbackRate={playbackRate} onLoadedMetadata={handleLoadedMetadata} onMediaPlayRequest={handlePlayRequest} onPlay={handlePlay} onPlayFail={handlePlayFail} onMediaSeekRequest={t15} onPlaying={handlePlaying} onPause={handlePause} onTimeUpdate={handleTimeUpdate} onVolumeChange={handleVolumeChange} onError={handleError} onCanPlay={onLoaded} onLoadStart={onLoadStart}>{t16}{children}</MediaPlayer>;
    $[26] = children;
    $[27] = handleError;
    $[28] = handleLoadedMetadata;
    $[29] = handlePause;
    $[30] = handlePlay;
    $[31] = handlePlayFail;
    $[32] = handlePlayRequest;
    $[33] = handlePlaying;
    $[34] = handleTimeUpdate;
    $[35] = handleVolumeChange;
    $[36] = muted;
    $[37] = onLoadStart;
    $[38] = onLoaded;
    $[39] = playbackRate;
    $[40] = poster;
    $[41] = source;
    $[42] = t15;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  return t17;
};
export default VidstackPlayer;